module.exports = __webpack_public_path__ + "img/mysticnarwhal.933aa282.png";